import { setInitialised, addWheelControls } from '@bao/carousel'
import { BAOCustomElement } from '@bao/custom-element'
import { getElements } from '@bao/utils'

const KeenSlider = window.KeenSlider

class HeaderDropdownNested extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.tabFocus = 0
    this.carousels = []

    this.els.slides?.elements.forEach((slidesEl) => {
      this.carousels.push(this.setupCarousel(slidesEl))
    })

    if (this.els.panel?.elements.length) {
      this.els.body.element.style.height = `${this.els.panel.elements[0].offsetHeight}px`
    }
  }

  setupListeners () {
    super.setupListeners()

    this.els.tab.elements.forEach((tabEl) => {
      tabEl.addEventListener('click', this.handleTabClick.bind(this))
    })

    this.els.tablist.element.addEventListener(
      'keydown',
      this.handleArrowPress.bind(this),
    )
  }

  handleTabClick (event) {
    const clickedTabEl = event.target.closest(this.els.tab.selector)

    if (!clickedTabEl) return

    this.els.tab.elements.forEach((tabEl) => {
      tabEl.setAttribute('aria-selected', tabEl === clickedTabEl)
    })

    this.els.panel.elements.forEach((panelEl) => {
      const match = panelEl.id === clickedTabEl.getAttribute('aria-controls')
      panelEl.setAttribute('aria-hidden', !match)

      if (match) {
        this.els.body.element.style.height = `${panelEl.offsetHeight}px`
      }
    })
  }

  handleArrowPress (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return

    this.els.tab.elements[this.tabFocus].setAttribute('tabindex', -1)

    if (event.key === 'ArrowRight') {
      this.tabFocus++
      // If we're at the end, go to the start
      if (this.tabFocus >= this.els.tab.elements.length) {
        this.tabFocus = 0
      }
      // Move left
    } else if (event.key === 'ArrowLeft') {
      this.tabFocus--
      // If we're at the start, move to the end
      if (this.tabFocus < 0) {
        this.tabFocus = this.els.tab.elements.length - 1
      }
    }

    this.els.tab.elements[this.tabFocus].setAttribute('tabindex', 0)
    this.els.tab.elements[this.tabFocus].focus()
  }

  setupCarousel (slidesEl) {
    const slideEls = getElements(this.els.slide.selector, {
      context: slidesEl,
    })

    if (!slideEls.length) return

    return new KeenSlider(
      slidesEl,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1000,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 0,
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('header-dropdown-nested')) {
  customElements.define('header-dropdown-nested', HeaderDropdownNested)
}
